module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a5f5538be9142e8bed53b7c7b1e558c0.png";